import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router';
import classNames from 'classnames';
import { readComponentInstanceResourceList } from 'lib/frankly';
import { buildQueryString } from 'utils/UrlUtils';
import ComponentContainer from 'components/core/ComponentContainer';

const RESULT_TYPE_PARAM = '1,2';

const SearchResultType = {
  '1': 'story',
  '2': 'clip'
};

const TextAlignHeaderType = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

const OPTIONAL_WIDGETS_PLACEMENT = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center',
  auto: 'space-around'
};

class CustomAnchor extends Component {
  static propTypes = {
    href: PropTypes.string,
    style: PropTypes.object,
    hoverStyle: PropTypes.object,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string
    ])
  }

  static defaultProps = {
    style: {},
    hoverStyle: {}
  }

  state = {
    hover: false
  }

  render() {
    const {
      children,
      style,
      hoverStyle,
      ...props
    } = this.props;
    const {
      hover
    } = this.state;

    let mergedStyle = _.clone(style);

    if (hover) {
      mergedStyle = _.assign(mergedStyle, _.mapValues(hoverStyle, val => val));
    }

    return (
      <a
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        {...props}
        style={mergedStyle}>
        {children}
      </a>
    );
  }
}

class Header extends Component {
  static propTypes = {
    FRN_componentInstanceId: PropTypes.string,
    showAd: PropTypes.bool,
    enableSearch: PropTypes.bool,
    textAlign: PropTypes.string,
    backgroundColor: PropTypes.string,
    backgroundImage: PropTypes.string,
    navstackBackgroundColor: PropTypes.string,
    subNavstackBackgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    menuLineColor: PropTypes.string,
    menuItemHoverStyle: PropTypes.object,
    searchOptions: PropTypes.shape({
      numberItems: PropTypes.number,
      backgroundColor: PropTypes.string,
      hoverBackgroundColor: PropTypes.string,
      textColor: PropTypes.string,
      textAlignment: PropTypes.string,
      displayResultsOnNewPage: PropTypes.bool
    }),
    menu: PropTypes.array,
    optionalWidgetsPlacement: PropTypes.oneOf(Object.keys(OPTIONAL_WIDGETS_PLACEMENT)),
    optionalWidgets: PropTypes.array,
    memberWidget: PropTypes.object,
    widget: PropTypes.object
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    showAd: false,
    enableSearch: true,
    textAlign: TextAlignHeaderType.LEFT,
    backgroundColor: '#FFF',
    navstackBackgroundColor: '#FFF',
    subNavstackBackgroundColor: '#FFF',
    textColor: '#000',
    menuLineColor: '',
    menuItemHoverStyle: {},
    searchOptions: {
      numberItems: 10,
      backgroundColor: '#FFF',
      textColor: '#000',
      textAlignment: TextAlignHeaderType.RIGHT,
      displayResultsOnNewPage: true
    },
    optionalWidgetsPlacement: 'right'
  }

  state = {
    showMobileSearchBar: false
  }

  _toggleMobileSearchBar() {
    this.setState({showMobileSearchBar: !this.state.showMobileSearchBar});
  }

  _hideMobileSearchBar() {
    this.setState({showMobileSearchBar: false});
  }

  _onClickSearchMenuItem() {
    this._toggleMobileSearchBar();
    window['$']('body').animate({ scrollTop: 0 }, 500);
  }

  render() {
    const {
      config: {
        affiliate: {
          logo = ''
          } = {},
        header = []
        } = {}
      } = this.context;

    const {
      FRN_componentInstanceId,
      showAd,
      enableSearch,
      textAlign,
      backgroundColor,
      backgroundImage,
      navstackBackgroundColor,
      subNavstackBackgroundColor,
      textColor,
      menuLineColor,
      menuItemHoverStyle,
      searchOptions: {
        numberItems: numberOfSearchItems,
        backgroundColor: searchBackgroundColor,
        textColor: searchTextColor,
        textAlignment: searchTextAlignment,
        displayResultsOnNewPage
        } = {},
      menu: menuItems = [],
      optionalWidgets: optionalWidgetsComponentDefinition = [],
      optionalWidgetsPlacement,
      memberWidget: memberWidgetComponentDefinition,
      widget: widgetComponentDefinition
    } = this.props;

    const {
      showMobileSearchBar
    } = this.state;

    const backgroundStyles = {};
    if (backgroundImage) {
      backgroundStyles['backgroundImage'] = `url(${backgroundImage})`;
    } else {
      backgroundStyles['backgroundColor'] = backgroundColor;
    }

    const menuItemComponents = menuItems.map((item, i) => {
      const menuLineStyles = {
        borderRightColor: menuLineColor && i < menuItems.length - 1 ? menuLineColor : null
      };
      return (
        <HeaderMenu
          style={menuLineStyles}
          key={i}
          item={item}
          subNavstackBackgroundColor={subNavstackBackgroundColor}
          menuItemHoverStyle={menuItemHoverStyle}
          />
      );
    });

    if (enableSearch) {
      menuItemComponents.push(
        <li key={menuItems.length}
          className="TallHeaderMenu TallHeaderMenu-search"
          data-toggle="collapse" data-target="#navbar"
          onClick={() => this._onClickSearchMenuItem()} >
          <a className="TallHeaderMenu-link TallHeaderMenu-top" >
            <i className="fa fa-search" aria-hidden="true"></i> Search
          </a>
        </li>
      );
    }

    const optionalWidgetsContent = [];

    optionalWidgetsComponentDefinition.forEach((optionalWidgetComponentDefinition, index) => {
      const isAd = _.includes(optionalWidgetComponentDefinition.id, 'AdvertisementUnit');

      const optionalWidgetClassnames = classNames(
        'TallHeader-optionalWidget',
        {
          'hidden-md': isAd,
        }
      );

      const optionalWidgetContent = (<div key={index} className={optionalWidgetClassnames}>
        <ComponentContainer
          componentDefinition={optionalWidgetComponentDefinition}
          componentInstanceId={_.isArray(header) ? `${FRN_componentInstanceId}.props.optionalWidgets[${index}]` : 'header.optionalWidgets[${index}]'}
        />
      </div>);

      if (showAd || !isAd) {
        optionalWidgetsContent.push(optionalWidgetContent);
      }
    });

    return (
      <div className="TallHeader header-sticky" style={!navstackBackgroundColor ? backgroundStyles : null}>
        <div className="TallHeader-top" style={navstackBackgroundColor ? backgroundStyles : null}>
          <div className="container">
            <Col className="TallHeader-navbar--toggleIcon TallHeader-middleContent" sm={1} xs={2}>
              <div type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar" onClick={() => this._hideMobileSearchBar()}>
                <svg x="0px" y="0px" width="24px" height="24px" viewBox="0 0 36 36" xmlSpace="preserve">
                  <line x1="4" y1="18" x2="32" y2="18" />
                  <line x1="4" y1="6" x2="32" y2="6" />
                  <line x1="4" y1="30" x2="32" y2="30" />
                </svg>
              </div>
            </Col>
            <Col lg={10} md={9} sm={9} xs={7} className="TallHeader-main TallHeader-middleContent">
              <div className="TallHeader-mainContent TallHeader-verticalAlignContent">
                <Link to='/' className="TallHeader-logo">
                  <img src={logo} alt="logo"/>
                </Link>
                {
                  !_.isEmpty(optionalWidgetsContent) && <div className="TallHeader-optionalWidgets hidden-xs hidden-sm">
                    <div className="TallHeader-optionalWidgetsContent TallHeader-verticalAlignContent" style={{ justifyContent: OPTIONAL_WIDGETS_PLACEMENT[optionalWidgetsPlacement] }}>
                      {optionalWidgetsContent}
                    </div>
                  </div>
                }
              </div>
            </Col>
            <Col lg={2} md={3} sm={2} xs={3} className="TallHeader-weatherWidget TallHeader-middleContent">
              {
                widgetComponentDefinition && <ComponentContainer
                  componentDefinition={widgetComponentDefinition}
                  // NOTE: Remove once we deprecate all object header's.
                  componentInstanceId={_.isArray(header) ? `${FRN_componentInstanceId}.props.widget` : 'header.widget'}
                />
              }
              {
                memberWidgetComponentDefinition && <ComponentContainer
                  componentDefinition={memberWidgetComponentDefinition}
                  componentInstanceId={_.isArray(header) ? `${FRN_componentInstanceId}.props.memberWidget` : 'header.memberWidget'}
                />
              }
            </Col>
          </div>
        </div>
        <div className="TallHeader-navigation" style={{backgroundColor: navstackBackgroundColor}}>
          <div className="container">
            <nav className="navbar navbar-default">
              <div id="navbar" className="navbar-collapse collapse" aria-expanded="false">
                <ul className="nav navbar-nav" style={{float: textAlign !== TextAlignHeaderType.CENTER ? textAlign : null, color: textColor}}>
                  {menuItemComponents}
                </ul>
              </div>
            </nav>
            {showMobileSearchBar && <MobileHeaderSearch
              numberOfSearchItems={numberOfSearchItems}
              searchBackgroundColor={searchBackgroundColor}
              searchTextColor={searchTextColor}
              searchTextAlignment={searchTextAlignment}
              toggleMobileSearchBar={() => this._toggleMobileSearchBar()}
              headerContext={this}
              displayResultsOnNewPage={displayResultsOnNewPage}
              /> }
            {enableSearch ? <HeaderSearch
              numberOfSearchItems={numberOfSearchItems}
              searchBackgroundColor={searchBackgroundColor}
              searchTextColor={searchTextColor}
              searchTextAlignment={searchTextAlignment}
              headerContext={this}
              displayResultsOnNewPage={displayResultsOnNewPage}
            /> : null}
          </div>
        </div>
      </div>
    );
  }
}

class HeaderMenu extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    subNavstackBackgroundColor: PropTypes.string,
    submenu: PropTypes.bool,
    style: PropTypes.object,
    menuItemHoverStyle: PropTypes.object
  }

  static defaultProps = {
    subNavstackBackgroundColor: "#FFF",
    submenu: false
  }

  render() {
    const {
      item: {
        text,
        href,
        target = '_self',
        menu = []
        },
      subNavstackBackgroundColor,
      submenu,
      style,
      menuItemHoverStyle
    } = this.props;

    const menuItemComponents = menu.map((item, i) => {
      return (
        <HeaderMenu
          key={i}
          style={style}
          submenu
          item={item}
          subNavstackBackgroundColor={subNavstackBackgroundColor}
          menuItemHoverStyle={menuItemHoverStyle}
          />
      );
    });

    const componentClassName = classNames(
      'TallHeaderMenu',
      {
        'dropdown': menuItemComponents.length && !submenu,
        'dropdown-submenu': menuItemComponents.length && submenu
      }
    );

    /*eslint-disable no-script-url*/
    const menuLink = submenu ?
      <CustomAnchor
        className="TallHeaderMenu-link"
        href="javascript: void(0);"
        style={{color: '#FFF'}}
        hoverStyle={menuItemHoverStyle}
        >{text}</CustomAnchor> :
      [<CustomAnchor
        href={href}
        key="0"
        className="TallHeaderMenu-link TallHeaderMenu-top"
        target={target}
        hoverStyle={menuItemHoverStyle}
        >
        {text}
      </CustomAnchor>,
      <CustomAnchor
        key="1"
        data-toggle="dropdown"
        aria-expanded="false"
        className="TallHeaderMenu-link dropdown-toggle TallHeaderMenu-topMenuDropdownIcon">
        <span className="caret hidden-sm hidden-xs"></span>
      </CustomAnchor>];
    /*eslint-enable no-script-url*/

    return (
      <li className={componentClassName} style={style}>
        { menuItemComponents.length ?
            menuLink :
            <CustomAnchor
              className="TallHeaderMenu-link TallHeaderMenu-top"
              href={href}
              target={target}
              hoverStyle={menuItemHoverStyle}>{text}</CustomAnchor> }

        { menuItemComponents.length ?
          <ul className="dropdown-menu" style={{backgroundColor: subNavstackBackgroundColor}}>
            {menuItemComponents}
          </ul> : null}
      </li>
    );
  }
}

class HeaderSearch extends Component {
  static propTypes = {
    numberOfSearchItems: PropTypes.number,
    searchBackgroundColor: PropTypes.string,
    searchTextColor: PropTypes.string,
    searchTextAlignment: PropTypes.string,
    headerContext: PropTypes.object,
    displayResultsOnNewPage: PropTypes.bool
  }

  static defaultProps = {
    numberOfSearchItems: 10,
    searchBackgroundColor: '#FFF',
    searchTextColor: '#000',
    searchTextAlignment: TextAlignHeaderType.RIGHT,
    displayResultsOnNewPage: true
  }

  state = {
    showSearchBar: false
  }

  _toggleSearchBar() {
    this.setState({
      showSearchBar: !this.state.showSearchBar,
      searchResults: {}
    });
  }

  render() {
    const {
      numberOfSearchItems,
      searchBackgroundColor,
      searchTextColor,
      searchTextAlignment,
      headerContext,
      displayResultsOnNewPage
    } = this.props;

    const { showSearchBar } = this.state;

    return (
      <div className="TallHeaderSearchBar hidden-sm hidden-xs" style={{color: searchTextColor}}>
        <button className="TallHeaderSearchBar-icon" onClick={() => this._toggleSearchBar()}>
          {!showSearchBar ? <i className="fa fa-search" aria-hidden="true"></i>
            : <i className="fa fa-times" aria-hidden="true"></i>}
        </button>
        {showSearchBar ?
          <SearchBar
            numberOfSearchItems={numberOfSearchItems}
            searchBackgroundColor={searchBackgroundColor}
            searchTextColor={searchTextColor}
            searchTextAlignment={searchTextAlignment}
            headerContext={headerContext}
            displayResultsOnNewPage={displayResultsOnNewPage}
          /> : null}
      </div>
    );
  }
}

class MobileHeaderSearch extends Component {
  static propTypes = {
    numberOfSearchItems: PropTypes.number,
    searchBackgroundColor: PropTypes.string,
    searchTextColor: PropTypes.string,
    searchTextAlignment: PropTypes.string,
    toggleMobileSearchBar: PropTypes.func.isRequired,
    headerContext: PropTypes.object,
    displayResultsOnNewPage: PropTypes.bool
  }

  static defaultProps = {
    numberOfSearchItems: 10,
    searchBackgroundColor: '#FFF',
    searchTextColor: '#000',
    searchTextAlignment: TextAlignHeaderType.RIGHT,
    displayResultsOnNewPage: true
  }

  render() {
    const {
      numberOfSearchItems,
      searchBackgroundColor,
      searchTextColor,
      searchTextAlignment,
      toggleMobileSearchBar,
      headerContext,
      displayResultsOnNewPage
    } = this.props;

    return (
      <div className="TallMobileHeaderSearchBar hidden-md hidden-lg" style={{color: searchTextColor}}>
        <div style={{backgroundColor: searchBackgroundColor}}>
          <div className="TallMobileHeaderSearchBar-cancelIcon"><i data-toggle="collapse" data-target="#navbar" className="fa fa-times" onClick={() => toggleMobileSearchBar()}/></div>
          <SearchBar
            numberOfSearchItems={numberOfSearchItems}
            searchBackgroundColor={searchBackgroundColor}
            searchTextColor={searchTextColor}
            searchTextAlignment={searchTextAlignment}
            headerContext={headerContext}
            displayResultsOnNewPage={displayResultsOnNewPage}
          />
        </div>
      </div>
    );
  }
}

class SearchBar extends Component {
  static propTypes = {
    numberOfSearchItems: PropTypes.number,
    searchBackgroundColor: PropTypes.string,
    searchTextColor: PropTypes.string,
    searchTextAlignment: PropTypes.string,
    headerContext: PropTypes.object,
    displayResultsOnNewPage: PropTypes.bool
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    numberOfSearchItems: 10,
    searchBackgroundColor: '#FFF',
    searchTextColor: '#000',
    searchTextAlignment: TextAlignHeaderType.RIGHT,
    displayResultsOnNewPage: true
  }

  state = {
    searchResults: null
  }

  _searchKeyEnter(e) {
    if (e.key === 'Enter') {
      this._search();
    }
  }

  _search() {
    const { value } = this.refs.searchInput;
    if (value.length > 1) {
      this._getData(value);
    } else {
      this.setState({ searchResults: {} });
    }
  }

  _getData(value) {
    const {
      config: {
        affiliate: {
          id
          } = {}
        } = {}
      } = this.context;
    const {
      numberOfSearchItems,
      headerContext,
      displayResultsOnNewPage
    } = this.props;
    const searchParams = {
      affiliateno: id,
      resulttype: RESULT_TYPE_PARAM,
      qu: value,
      num: numberOfSearchItems
    };

    const searchParamsString = buildQueryString(searchParams);

    if (displayResultsOnNewPage){
      const href = location.protocol + '//' + location.hostname
        + (location.port ? ':' + location.port : '')
        + '/search?qu=' + value + '&num=' + numberOfSearchItems;
      location.href = href;
    } else {
      readComponentInstanceResourceList(headerContext, { propPath: `searchOptions`, vars: { params: searchParamsString } }).then(rawResponse => {
        this.setState({ searchResults: rawResponse[0] });
      }).catch(() => {
        this.setState({ searchResults: {} });
      });
    }
  }

  render() {
    const {
      searchBackgroundColor,
      searchTextColor,
      searchTextAlignment
      } = this.props;

    const {
      searchResults
      } = this.state;

    const componentStyle = {
      backgroundColor: searchBackgroundColor,
      color: searchTextColor
    };

    let searchContent = [];
    if (searchResults) {
      const {
        data: {
          SEARCH: {
            RESULTS: {
              RESULT: results = []
              } = {}
            } = {}
          } = {}
        } = searchResults;

      searchContent = results.map((item, index) => {
        const { SEO: {
          PAGEURL = ''
          } = {}
          } = item;

        const rootPath = SearchResultType[item.SEARCHRESULTTYPE];

        if (!rootPath) {
          return null;
        }

        return (
          <li key={index} style={{textAlign: searchTextAlignment}}>
            <a href={`/${rootPath}/${item.TITLE}/${PAGEURL}`}>{item.HEADLINE}</a>
          </li>
        );
      });
    }

    if (searchContent.length) {
        searchContent.unshift(<li style={{textAlign: searchTextAlignment}}>Results</li>);
    }

    return (
      <div className="SearchBar" style={componentStyle}>
        <div className="input-group">
          <input
            autoFocus
            ref="searchInput"
            className="form-control"
            onKeyPress={(e) => this._searchKeyEnter(e)}
            placeholder="Enter text here..."/>
          <span className="input-group-btn">
            <button onClick={() => this._search()}>GO</button>
          </span>
        </div>
        <ul className="SearchBar-result" style={componentStyle}>
          {searchContent}
        </ul>
      </div>
    );
  }
}


export default Header;



// WEBPACK FOOTER //
// ./app/components/custom/heartland/core/Header.js